<template>
  <b-navbar
    :sticky="true"
    fixed="top"
    toggleable="md"
    type="dark"
    variant="primary"
  >
    <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

    <!-- <b-navbar-brand href="#">GOLS <span style="color: red;">(TESTING)</span></b-navbar-brand> -->
    <!-- <b-navbar-brand href="#">GOLS</b-navbar-brand> -->
    <b-navbar-brand href="#">
      <span>GOLS</span>
      <!-- <img style="height:30px;" src="https://tracking.gols.com.hk/sleb_cms/uploads/shangri-la_boutique_logo.png"/> -->
    </b-navbar-brand>

    <b-collapse is-nav id="nav_collapse">
      <b-navbar-nav v-if="$store.state.user_obj.first_time_login != '1'">
        <!-- <b-navbar-nav> -->
        <b-nav-item-dropdown
          text="Order Management"
          right
          v-if="
            $store.state.user_obj &&
            checkPermission(
              $store.state.user_obj,
              'Order Management',
              false,
              false,
              $store.state.user_obj.permissions.nav_order
            )
          "
        >
          <b-dropdown-item
            :to="{ name: 'order_master', params: {} }"
            v-if="
              checkPermission(
                $store.state.user_obj,
                'Order Management',
                'Order Master',
                'Order View',
                true
              )
            "
            >Order Master</b-dropdown-item
          >
          <b-dropdown-item
            :to="{ name: 'client_dashboard', params: {} }"
            v-if="
              checkPermission(
                $store.state.user_obj,
                'Order Management',
                'Order Master',
                'Client Dashboard',
                $store.state.user_obj.permissions.nav_order
              )
            "
            >Client Dashboard</b-dropdown-item
          >
          <b-dropdown-item
            :to="{ name: 'order_inventory', params: {} }"
            v-if="
            checkPermission(
                $store.state.user_obj,
                'Order Management',
                'Order Inventory',
                false,
                $store.state.user_obj &&
                $store.state.user_obj.client_id != '19' &&
                $store.state.user_obj.user_name != 'litomon_client'
              )
            "
            >Order Inventory</b-dropdown-item
          >
          <!-- <b-dropdown-item :to="{ name: 'fulfillment_process', params: {}}">Fulfillment Process</b-dropdown-item> -->
          <b-dropdown-item
            v-if="
              $store.state.user_obj &&
              $store.state.user_obj.permissions.nav_shopify_order &&
              $store.state.user_obj.user_name != 'litomon_client' &&
              $store.state.user_obj.user_name != 'kwh_client'
            "
            :to="{ name: 'shopify_orders', params: {} }"
            >Shopify Orders</b-dropdown-item
          >
          <b-dropdown-item
            :to="{ name: 'back_orders', params: {} }"
            v-if="
              $store.state.user_obj &&
              checkPermission(
                $store.state.user_obj,
                'Order Management',
                'Back Order',
                false,
                $store.state.user_obj.user_name != 'armubuy_client' &&
                  $store.state.user_obj.user_name != 'litomon_client'
              )
            "
            >Back Order</b-dropdown-item
          >
          <b-dropdown-item
            v-if="
              $store.state.user_obj &&
              checkPermission(
                $store.state.user_obj,
                'Order Management',
                'Committed Product',
                false,
                $store.state.user_obj.permissions.nav_committed_products &&
                  $store.state.user_obj.user_name != 'litomon_client'
              )
            "
            :to="{ name: 'committed_products', params: {} }"
            >Committed Product</b-dropdown-item
          >
        </b-nav-item-dropdown>

        <b-nav-item-dropdown
          text="Delivery Management"
          right
          v-if="
            $store.state.user_obj &&
            $store.state.user_obj.user_id != '1094' && 
            checkPermission(
              $store.state.user_obj,
              'Delivery Management',
              false,
              false,
              $store.state.user_obj.permissions.nav_tracking
            )
          "
        >
          <b-dropdown-item
            :to="{ name: 'trackings', params: {} }"
            v-if="
              checkPermission(
                $store.state.user_obj,
                'Delivery Management',
                'Delivery Status',
                false,
                true
              )
            "
            >Delivery Status</b-dropdown-item
          >

          <b-dropdown-item
            :to="{ name: 'international_tracking', params: {} }"
            v-if="
              checkPermission(
                $store.state.user_obj,
                'Delivery Management',
                'International Tracking',
                false,
                true
              )
            "
            >International Tracking</b-dropdown-item
          >

          <b-dropdown-item
            :to="{ name: 'redemption_status', params: {} }"
            v-if="
              checkPermission(
                $store.state.user_obj,
                'Delivery Management',
                'Redemption Status',
                false,
                true
              )
            "
            >Redemption Status</b-dropdown-item
          >
          <b-dropdown-item
            v-if="
              $store.state.user_obj &&
              checkPermission(
                $store.state.user_obj,
                'Delivery Management',
                'Delivery Note',
                false,
                $store.state.user_obj.user_name != 'litomon_client'
              )
            "
            :to="{ name: 'delivery_note', params: {} }"
            >Delivery Note</b-dropdown-item
          >
          <b-dropdown-item
            v-if="
              $store.state.user_obj &&
              checkPermission(
                $store.state.user_obj,
                'Delivery Management',
                'Collection Note',
                false,
                $store.state.user_obj.user_name != 'litomon_client'
              )
            "
            :to="{ name: 'collection_note', params: {} }"
            >Collection Note</b-dropdown-item
          >
          <b-dropdown-item
            :to="{ name: 'route_allocation', params: {} }"
            v-if="
              $store.state.user_obj &&
              $store.state.user_obj.permissions.route_allocation &&
              $store.state.user_obj.user_name != 'litomon_client'
            "
            >Route Allocation</b-dropdown-item
          >
          <b-dropdown-item
            :to="{ name: 'external_route_allocation', params: {} }"
            v-if="
              $store.state.user_obj &&
              $store.state.user_obj.permissions.route_allocation &&
              $store.state.user_obj.user_name != 'litomon_client'
            "
            >External Route Allocation</b-dropdown-item
          >
          <b-dropdown-item
            v-if="
              $store.state.user_obj &&
              checkPermission(
                $store.state.user_obj,
                'Delivery Management',
                'Reschedule Delivery',
                false,
                true
              )
            "
            :to="{ name: 'reschedule_delivery', params: {} }"
            >Reschedule Delivery</b-dropdown-item
          >

          <b-dropdown-item
            v-if="
              $store.state.user_obj &&
              checkPermission(
                $store.state.user_obj,
                'Delivery Management',
                'Route Update',
                false,
                true
              )
            "
            :to="{ name: 'route_update', params: {} }"
            >Route Update</b-dropdown-item
          >

          <b-dropdown-item
            v-if="
              $store.state.user_obj &&
              ($store.state.user_obj.account_type == 'client_admin' ||
              $store.state.user_obj.account_type == 'driver_route')
            "
            :to="{ name: 'delivery_dashboard', params: {} }"
            >Delivery Dashboard</b-dropdown-item
          >
          <!-- <b-dropdown-item :to="{ name: 'tracking_location_scan', params: {}}">Tracking Location</b-dropdown-item> -->
          <b-dropdown-item v-if="
              $store.state.user_obj &&
              checkPermission(
                $store.state.user_obj,
                'Delivery Management',
                'Tracking SMS',
                false,
                $store.state.user_obj.permissions.nav_tracking_sms
              )
            " :to="{ name: 'tracking_sms', params: {}}">Tracking SMS</b-dropdown-item>
          <!-- <b-dropdown-item :to="{ name: 'wms_return_orders', params: {}}">Return Orders</b-dropdown-item> -->
          <b-dropdown-item v-if="
              $store.state.user_obj &&
              checkPermission(
                $store.state.user_obj,
                'Delivery Management',
                'Tracking Return Process',
                false,
                $store.state.user_obj.permissions.nav_tracking_return_process
              )
            " :to="{ name: 'tracking_return_process', params: {}}">Tracking Return Process</b-dropdown-item>
        </b-nav-item-dropdown>

        <b-nav-item-dropdown
          text="Delivery Management"
          right
          v-if="
            $store.state.user_obj &&
            $store.state.user_obj.user_id == '1297'
          "
        >
          <b-dropdown-item
            :to="{ name: 'trackings', params: {} }"
            v-if="
              checkPermission(
                $store.state.user_obj,
                'Delivery Management',
                'Delivery Status',
                false,
                true
              )
            "
            >Delivery Status</b-dropdown-item
          >
          <b-dropdown-item
            :to="{ name: 'route_allocation', params: {} }"
            v-if="
              $store.state.user_obj &&
              $store.state.user_obj.permissions.route_allocation &&
              $store.state.user_obj.user_name != 'litomon_client'
            "
            >Route Allocation</b-dropdown-item
          >
          <b-dropdown-item
            v-if="
              $store.state.user_obj &&
              checkPermission(
                $store.state.user_obj,
                'Delivery Management',
                'Reschedule Delivery',
                false,
                true
              )
            "
            :to="{ name: 'reschedule_delivery', params: {} }"
            >Reschedule Delivery</b-dropdown-item
          >

          <b-dropdown-item
            v-if="
              $store.state.user_obj &&
              checkPermission(
                $store.state.user_obj,
                'Delivery Management',
                'Route Update',
                false,
                true
              )
            "
            :to="{ name: 'route_update', params: {} }"
            >Route Update</b-dropdown-item
          >

          <b-dropdown-item
            v-if="
              $store.state.user_obj &&
              ($store.state.user_obj.account_type == 'client_admin' ||
              $store.state.user_obj.account_type == 'driver_route')
            "
            :to="{ name: 'delivery_dashboard', params: {} }"
            >Delivery Dashboard</b-dropdown-item
          >
        </b-nav-item-dropdown>

        <b-nav-item
          v-if="
            $store.state.user_obj &&
            $store.state.user_obj.permissions.nav_driver_route
          "
          :to="{ name: 'route_allocation', params: {} }"
          >Route Allocation</b-nav-item
        >

        <b-nav-item
          v-if="
            $store.state.user_obj &&
            $store.state.user_obj.permissions.nav_vendor_orders
          "
          :to="{ name: 'vendor_orders', params: {} }"
          >Orders</b-nav-item
        >

        <b-nav-item-dropdown
          text="Vendor Management"
          right
          v-if="
            $store.state.user_obj &&
            checkPermission(
              $store.state.user_obj,
              'Vendor Management',
              false,
              false,
              $store.state.user_obj.permissions.nav_vendor
            )
          "
        >
          <!-- <b-dropdown-item :to="{ name: 'vendor_master', params: {}}">Vendor Master</b-dropdown-item> -->
          <b-dropdown-item
            :to="{ name: 'vendor_orders', params: {} }"
            v-if="
              checkPermission(
                $store.state.user_obj,
                'Vendor Management',
                'Order View',
                false,
                true
              )
            "
            >Order View</b-dropdown-item
          >
          <b-dropdown-item
            :to="{ name: 'vendor_products', params: {} }"
            v-if="
              $store.state.user_obj &&
              checkPermission(
                $store.state.user_obj,
                'Vendor Management',
                'Product View',
                false,
                $store.state.user_obj.account_type != 'vendor_warehouse'
              )
            "
            >Product View</b-dropdown-item
          >
        </b-nav-item-dropdown>

        <b-nav-item-dropdown
          text="Customer Service"
          right
          v-if="
            $store.state.user_obj &&
            checkPermission(
              $store.state.user_obj,
              'Customer Service',
              false,
              false,
              $store.state.user_obj.permissions.nav_customer_service
            )
          "
        >
          <b-dropdown-item
            v-if="
              checkPermission(
                $store.state.user_obj,
                'Customer Service',
                'Delivery Case',
                false,
                true
              )
            "
            :to="{ name: 'change_requests', params: {} }"
            >Delivery Case</b-dropdown-item
          >
          <b-dropdown-item
            v-if="
              $store.state.user_obj &&
              checkPermission(
                $store.state.user_obj,
                'Customer Service',
                'Other Case',
                false,
                $store.state.user_obj.user_name != 'litomon_client'
              )
            "
            :to="{ name: 'cs_issues', params: {} }"
            >CS Case</b-dropdown-item
          >
        </b-nav-item-dropdown>

        <!-- <b-nav-item-dropdown text="Shipments" right v-if="$store.state.user_obj && $store.state.user_obj.permissions.nav_shipment">
            <b-dropdown-item :to="{ name: 'inbound_shipments', params: {}}">Inbound Shipments</b-dropdown-item>
            <b-dropdown-item>Outbound Shipments</b-dropdown-item>
          </b-nav-item-dropdown> -->

        <b-nav-item-dropdown
          text="Warehouse Management"
          right
          v-if="
            $store.state.user_obj &&
            checkPermission(
              $store.state.user_obj,
              'Warehouse Management',
              false,
              false,
              $store.state.user_obj.permissions.nav_inventory
            )
          "
        >
          <b-dropdown-item
            v-if="
            false && 
              checkPermission(
                $store.state.user_obj,
                'Warehouse Management',
                'Inventory - Dashboard',
                false,
                true
              )
            "
            :to="{ name: 'stock_take_job', params: {} }"
            >Stock Take Job</b-dropdown-item
          >
          <b-dropdown-item
            v-if="
              checkPermission(
                $store.state.user_obj,
                'Warehouse Management',
                'Inventory - Dashboard',
                false,
                $store.state.user_obj.user_name != 'neoderm_client'
              )
            "
            :to="{ name: 'inventory_control', params: {} }"
            >Inventory - Dashboard</b-dropdown-item
          >
          <!-- <b-dropdown-item :to="{ name: 'inventory_control_new', params: {}}">Inventory - Dashboard [NEW]</b-dropdown-item> -->
          <b-dropdown-item
            v-if="
              checkPermission(
                $store.state.user_obj,
                'Warehouse Management',
                'Inventory - Transactions',
                false,
                true
              )
            "
            :to="{ name: 'wms_transactions', params: {} }"
            >Inventory - Transactions</b-dropdown-item
          >
          <b-dropdown-item
            v-if="
              $store.state.user_obj &&
              checkPermission(
                $store.state.user_obj,
                'Warehouse Management',
                'Inventory - Detailed View',
                false,
                true
              )
            "
            :to="{ name: 'wms_products', params: {} }"
            >Inventory - Detailed View</b-dropdown-item
          >
          <b-dropdown-item
            v-if="
              $store.state.user_obj &&
              checkPermission(
                $store.state.user_obj,
                'Warehouse Management',
                'Inventory - Cross-Platform Transfer',
                false,
                $store.state.user_obj.permissions.nav_cp_transfer
              )
            "
            :to="{ name: 'inventory_crossplatform_transfer', params: {} }"
            >Inventory - Cross-Platform Transfer</b-dropdown-item
          >
          <b-dropdown-item
            v-if="
              $store.state.user_obj &&
              checkPermission(
                $store.state.user_obj,
                'Warehouse Management',
                'Stock-in Process',
                false,
                $store.state.user_obj.permissions.nav_stockin_process &&
                  $store.state.user_obj.user_name != 'litomon_client' &&
                  $store.state.user_obj.user_name != 'neoderm_client'
              )
            "
            :to="{ name: 'stockin_process', params: {} }"
            >Stock-in Process</b-dropdown-item
          >
          <b-dropdown-item
            v-if="
              $store.state.user_obj &&
              checkPermission(
                $store.state.user_obj,
                'Warehouse Management',
                'Fulfilment Process',
                false,
                $store.state.user_obj.permissions.nav_fulfilment_process &&
                  $store.state.user_obj.user_name != 'litomon_client'
              )
            "
            :to="{ name: 'fulfillment_process_v2', params: {} }"
            >Fulfillment Process</b-dropdown-item
          >
          <b-dropdown-item
            v-if="
              $store.state.user_obj &&
              checkPermission(
                $store.state.user_obj,
                'Warehouse Management',
                'Inbound Shipments',
                false,
                $store.state.user_obj.permissions.nav_inbound_shipment
              )
            "
            :to="{ name: 'inbound_shipments', params: {} }"
            >Inbound Shipments</b-dropdown-item
          >

          <b-dropdown-item
            v-if="
              checkPermission(
                $store.state.user_obj,
                'Warehouse Management',
                'Picking Status',
                false,
                true
              )
            "
            :to="{ name: 'picking_status', params: {} }"
            >Picking Status</b-dropdown-item
          >

          <b-dropdown-item
            v-if="
              checkPermission(
                $store.state.user_obj,
                'Warehouse Management',
                'Carton Amendment',
                false,
                true
              )
            "
            :to="{ name: 'carton_amendment', params: {} }"
            >Carton Amendment</b-dropdown-item
          >

          <b-dropdown-item
            v-if="
              checkPermission(
                $store.state.user_obj,
                'Warehouse Management',
                'Print PDF Portal',
                false,
                true
              )
            "
            :to="{ name: 'print_pdf_portal', params: {} }"
            >Print PDF Portal</b-dropdown-item
          >

          <b-dropdown-item
            v-if="
              checkPermission(
                $store.state.user_obj,
                'Warehouse Management',
                'Packing Queue',
                false,
                true
              )
            "
            :to="{ name: 'packing_queue', params: {} }"
            >Packing Queue</b-dropdown-item
          >
          <b-dropdown-item
            v-if="
              checkPermission(
                $store.state.user_obj,
                'Warehouse Management',
                'Packing Process',
                false,
                true
              )
            "
            :to="{ name: 'packing_process', params: {} }"
            >Packing Log</b-dropdown-item
          >
          <b-dropdown-item
            v-if="
              checkPermission(
                $store.state.user_obj,
                'Warehouse Management',
                'Fulfilment Process',
                false,
                true
              )
            "
            :to="{ name: 'productLocationBulk', params: {} }"
            >Bulk Edit Pickup Location</b-dropdown-item
          >
        </b-nav-item-dropdown>

        <b-nav-item-dropdown
          text="Controls"
          right
          v-if="
            $store.state.user_obj &&
            checkPermission(
              $store.state.user_obj,
              'Controls',
              false,
              false,
              $store.state.user_obj.permissions.nav_control
            )
          "
        >
          <b-dropdown-item
            v-if="
              checkPermission(
                $store.state.user_obj,
                'Controls',
                'SKU Master',
                false,
                true
              )
            "
            :to="{ name: 'product_master', params: {} }"
            >SKU Master</b-dropdown-item
          >
          <!-- <b-dropdown-item :to="{ name: 'gols_sku_master', params: {}}">GOLS SKU Master</b-dropdown-item> -->
          <b-dropdown-item
            v-if="
              $store.state.user_obj &&
              checkPermission(
                $store.state.user_obj,
                'Controls',
                'Location Master',
                false,
                $store.state.user_obj.user_name != 'litomon_client'
              )
            "
            :to="{ name: 'wms_locations', params: {} }"
            >Location Master</b-dropdown-item
          >
          <b-dropdown-item
            v-if="
              checkPermission(
                $store.state.user_obj,
                'Controls',
                'Virtual Kit Master',
                false,
                true
              )
            "
            :to="{ name: 'virtual_kit_master', params: {} }"
            >Virtual Kit Master</b-dropdown-item
          >
          <b-dropdown-item
            v-if="
              checkPermission(
                $store.state.user_obj,
                'Controls',
                'Virtual Kit Master',
                false,
                true
              )
            "
            :to="{ name: 'virtual_kit_reverse_master', params: {} }"
            >Reverse Virtual Kit Master</b-dropdown-item
          >
          <!-- <b-dropdown-item :to="{ name: 'channel_master', params: {}}">Channel Master</b-dropdown-item> -->
          <b-dropdown-item
            v-if="
              $store.state.user_obj &&
              checkPermission(
                $store.state.user_obj,
                'Controls',
                'Vendor Master',
                false,
                $store.state.user_obj.permissions.nav_vendor &&
                  $store.state.user_obj.user_name != 'litomon_client'
              )
            "
            :to="{ name: 'vendor_master', params: {} }"
            >Vendor Master</b-dropdown-item
          >

          <!-- <b-dropdown-item :to="{ name: 'company_master', params: {}}">Company Master</b-dropdown-item> -->
          <b-dropdown-item
            v-if="
              $store.state.user_obj &&
              checkPermission(
                $store.state.user_obj,
                'Controls',
                'Redemption Location Master',
                false,
                $store.state.user_obj.user_name != 'litomon_client'
              )
            "
            :to="{ name: 'redemption_location_master', params: {} }"
            >Redemption Location Master</b-dropdown-item
          >
          <b-dropdown-item
            v-if="
              $store.state.user_obj
            "
            :to="{ name: 'address_template', params: {} }"
            >Address Template Master</b-dropdown-item
          >
        </b-nav-item-dropdown>

        <b-nav-item-dropdown
          text="Account"
          right
          v-if="
            $store.state.user_obj &&
            checkPermission(
              $store.state.user_obj,
              'Account',
              false,
              false,
              false
            )
          "
        >
          <b-dropdown-item
            v-if="
              $store.state.user_obj &&
              checkPermission(
                $store.state.user_obj,
                'Account',
                false,
                false,
                true
              )
            "
            :to="{ name: 'cms_account', params: {} }"
            >Account</b-dropdown-item
          >

          <b-dropdown-item
            v-if="
              $store.state.user_obj &&
              checkPermission(
                $store.state.user_obj,
                'Account',
                'Client',
                false,
                true
              )
            "
            :to="{ name: 'cms_client', params: {} }"
            >Client</b-dropdown-item
          >

          <b-dropdown-item
            v-if="
              $store.state.user_obj &&
              checkPermission(
                $store.state.user_obj,
                'Account',
                'Permission Group',
                false,
                true
              )
            "
            :to="{ name: 'cms_permission_group', params: {} }"
            >Permission Group</b-dropdown-item
          >
          <b-dropdown-item
            v-if="
            false && 
              $store.state.user_obj &&
              checkPermission(
                $store.state.user_obj,
                'Account',
                false,
                false,
                true
              )
            "
            :to="{ name: 'cms_change_log', params: {} }"
            >Change Log</b-dropdown-item
          >
          <b-dropdown-item
            v-if="
              $store.state.user_obj &&
              checkPermission(
                $store.state.user_obj,
                'Account',
                false,
                false,
                true
              )
            "
            :to="{ name: 'cms_barcode_reader', params: {} }"
            >Test Barcode Reader</b-dropdown-item
          >
        </b-nav-item-dropdown>

        <b-nav-item
          v-if="
            $store.state.user_obj &&
            $store.state.user_obj.permissions.nav_drivers
          "
          :to="{ name: 'drivers', params: {} }"
          >Drivers</b-nav-item
        >
        <b-nav-item
          v-if="
            $store.state.user_obj && $store.state.user_obj.permissions.nav_users
          "
          :to="{ name: 'users', params: {} }"
          >Users</b-nav-item
        >
        <b-nav-item
          v-if="
            $store.state.user_obj &&
            $store.state.user_obj.permissions.nav_clients
          "
          :to="{ name: 'clients', params: {} }"
          >Clients</b-nav-item
        >

        <b-nav-item
          v-if="
            $store.state.user_obj &&
            $store.state.user_obj.permissions.nav_hkt_orders
          "
          :to="{ name: 'hkt_orders', params: {} }"
          >Orders</b-nav-item
        >
        <b-nav-item
          v-if="
            $store.state.user_obj &&
            $store.state.user_obj.permissions.nav_cpr_orders
          "
          :to="{ name: 'cpr_orders', params: {} }"
          >Orders</b-nav-item
        >

        <b-nav-item
          v-if="
            $store.state.user_obj &&
            $store.state.user_obj.permissions.cms_category
          "
          :to="{ name: 'cms_category', params: {} }"
          >Category</b-nav-item
        >
        <!-- <b-nav-item
          v-if="$store.state.user_obj && $store.state.user_obj.account_type == 'sleb'"
          :to="{ name: 'fooklei_supplier', params: {} }"
          >Supplier</b-nav-item
        > -->
        <b-nav-item
          v-if="
            $store.state.user_obj &&
            $store.state.user_obj.permissions.cms_product
          "
          :to="{ name: 'cms_product', params: {} }"
          >Product</b-nav-item
        >
        <!-- <b-nav-item
          v-if="$store.state.user_obj && $store.state.user_obj.account_type == 'sleb'"
          :to="{ name: 'cms_coupon', params: {} }"
          >Coupon</b-nav-item
        > -->
        <!-- <b-nav-item
          v-if="$store.state.user_obj && $store.state.user_obj.account_type == 'sleb'"
          :to="{ name: 'cms_member', params: {} }"
          >Member</b-nav-item
        > -->
        <b-nav-item
          v-if="
            $store.state.user_obj &&
            ($store.state.user_obj.account_type == 'sleb_regional' ||
              $store.state.user_obj.account_type == 'sleb_admin')
          "
          :to="{ name: 'cms_banner', params: {} }"
          >Banner</b-nav-item
        >
        <b-nav-item
          v-if="
            $store.state.user_obj && $store.state.user_obj.permissions.cms_order
          "
          :to="{ name: 'cms_order', params: {} }"
          >Order</b-nav-item
        >

        <b-nav-item
          v-if="
            $store.state.user_obj &&
            $store.state.user_obj.permissions.cms_report
          "
          :to="{ name: 'cms_report', params: {} }"
          >Report</b-nav-item
        >

        <b-nav-item
          v-if="
            $store.state.user_obj &&
            $store.state.user_obj.permissions.cms_report
          "
          :to="{ name: 'cms_payment', params: {} }"
          >Payment</b-nav-item
        >
        <!-- <b-nav-item
          v-if="$store.state.user_obj && $store.state.user_obj.account_type == 'sleb'"
          :to="{ name: 'fooklei_payment_method', params: {} }"
          >Payment Method</b-nav-item
        >
        <b-nav-item
          v-if="$store.state.user_obj && $store.state.user_obj.account_type == 'sleb'"
          :to="{ name: 'fooklei_shippings', params: {} }"
          >Shipping Fee</b-nav-item
        > -->

        <b-nav-item
          v-if="
            $store.state.user_obj &&
            $store.state.user_obj.permissions.nav_redemption_center
          "
          :to="{ name: 'redemption_center', params: {} }"
          >Ready for Pickup</b-nav-item
        >
      </b-navbar-nav>

      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
        <b-nav-item v-if="$store.state.user_obj"
          ><small style="color: white">{{
            $store.state.user_obj.name
          }}</small></b-nav-item
        >
        <b-nav-item v-if="$store.state.user_obj" @click="logout"
          >Logout</b-nav-item
        >
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import global_function from "../mixins/global_function";

export default {
  name: "Header",
  mixins: [global_function],
  data() {
    return {
      eventHub: window.eventHub,
    };
  },
  mounted() {},
  methods: {
    logout() {
      this.$store.state.user_obj = false;
      localStorage.removeItem("user_obj");
      eventHub.$emit("user_logout");
      this.$router.replace("/login");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/Header.vue